import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { toastr } from 'react-redux-toastr';
import { dateUtilities, RequirePermissions, ssgFormsAdapters, numberUtils } from '../common';
import * as programEnrollmentUtils from '../common/program-enrollment-utilities';
import * as touchpointActions from './touchpoints.actions';
import * as programActions from '../programs/program.actions';
import * as programUtilities from '../common/program-utilities';
import { Title } from '../layout';
import queryString from 'query-string';
import { adapters } from '@social-solutions/ssg-forms-processing';
import { LoadingPane, SsgFormComponent, CustomIcon, CustomIconSet, ssgFormActions } from '@social-solutions/ssg-forms';
import './view-touchpoint-response.scss';

const ssgFormId = "view-form-response";

export class ViewTouchpointResponseComponent extends Component {
  componentDidMount() {
    const { touchpointActions, match, programActions, ssgFormActions } = this.props;
    const { params } = match;
    const { siteId, programId, touchpointFormId, responseId } = params;

    // Clear previous state
    ssgFormActions.hardReset(ssgFormId)
    touchpointActions.abandonTouchpointResponses();

    Promise.all([
      programActions.fetchAllPrograms(),
      touchpointActions.fetchTouchpointForm(siteId, programId, touchpointFormId, false, responseId),
      touchpointActions.fetchTouchpointResponse(siteId, programId, touchpointFormId, responseId),
    ]).catch(err => {
      toastr.error("Failure", "Failed to fetch the touchpoint form and response.");
    })
  }

  handleAttachmentDownload(formId, elementId, fileId) {
    const { touchpointActions, match } = this.props;
    const { params } = match;
    const { siteId, programId, responseId } = params;

    var guidElementId = numberUtils.convertIntToGuid(Number(elementId));

    return touchpointActions.fetchAttachment(siteId, programId, formId, responseId, guidElementId, fileId)
      .catch(error => {
        toastr.error("Failure", "Failed to download the attachment.");
      });
  }

  componentWillUnmount() {
    const { ssgFormActions, touchpointActions } = this.props;
    ssgFormActions.hardReset(ssgFormId);
    touchpointActions.abandonTouchpointResponses();
  }

  render() {
    const { touchpoints, match, redirectTo, routing, programEnrollment, programs } = this.props;

    const { params } = match;
    const { siteId, programId, touchpointFormId, responseId } = params;

    const touchpointFormState = ssgFormsAdapters.convertLoadingState(touchpoints.touchpointForms.get(touchpointFormId));
    const form = !!touchpointFormState && touchpointFormState.data;
    const fieldFormatSetting = !!form && form.fieldFormatSetting;

    const { location } = routing || {};
    const { search } = location || {};
    const query = queryString.parse(search);
    const redirectUrl = query.redirectUrl;

    const allProgramsState = ssgFormsAdapters.convertLoadingState(programs && programs.allPrograms);
    const allProgs = programUtilities.getAllPrograms(programs);
    const progsFromResponse = programUtilities.getProgramsFromTouchpointResponse(touchpoints, responseId);

    const touchpointResponseState = ssgFormsAdapters.convertLoadingState(touchpoints.touchpointResponses.get(responseId));
    const { data : existingResponse } = touchpointResponseState || {};
    var dateTaken = existingResponse && existingResponse.responseCreatedDate;

    const formName = programEnrollmentUtils.getFormAlias(programEnrollment, siteId, programId, touchpointFormId);
    const touchpointAnswers = form && existingResponse && adapters.convertJsonResponse(form, existingResponse);

    const formProps = {
      id: ssgFormId,
      form: {
        ...form,
        name: formName
      },
      initialValues: touchpointAnswers,
      readOnly: true,
      buttonLayout: [
        {
          id: 'close',
          display: 'Close',
          buttonType: 'default',
          functionType: 'none',
          onClick: (state) => redirectTo(redirectUrl ? redirectUrl : '/'),
        }
      ],
      onDownloadAttachment: (formId, elementId, fileId) => this.handleAttachmentDownload(formId, elementId, fileId),
      showRequiredKey: true,
      allPrograms: allProgs,
      initialSelectedPrograms: progsFromResponse,
      css: {
        form: "ssg-form form-display has-page-title",
        formBody: 'ssg-forms-body',
        actions: "ssg-forms-actions form-actions-display",
      },
      country: fieldFormatSetting
    };

    return (
      <RequirePermissions
        siteId={siteId}
        programId={programId}
        formId={touchpointFormId}
        requireView={true}>
        <Title title="View Form Response"/>
        <LoadingPane id="fetchLoadingPane" loadingState={[touchpointFormState, touchpointResponseState, allProgramsState]}>
            <div>
              <button
                id='back-button'
                className="ssg-forms-icon-btn"
                title="Back"
                aria-label={"back"}
                onClick={() => redirectTo(redirectUrl ? redirectUrl : '/')}>
                <CustomIcon iconChoice={CustomIconSet.ic_left_arrow_18x18} />
              </button>
              <h1 className="ssg-forms-text xl page-title view-response-header">
                Submitted {dateTaken ? dateUtilities.getUserFriendlyFormatFromJson(dateTaken) : ""}
              </h1>
            </div>
            <SsgFormComponent {...formProps} />
        </LoadingPane>
      </RequirePermissions>
    );
  }
}

ViewTouchpointResponseComponent.propTypes = {
  touchpointActions: PropTypes.object.isRequired,
  touchpoints: PropTypes.object.isRequired,

  match: PropTypes.shape({
    params: PropTypes.shape({
      siteId: PropTypes.isRequired,
      programId: PropTypes.isRequired,
      touchpointFormId: PropTypes.isRequired
    })
  })
};

const mapStateToProps = ({ routing, touchpoints, programEnrollment, programs }) => {
  return {
    routing,
    touchpoints,
    programEnrollment,
    programs
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    touchpointActions: bindActionCreators(touchpointActions, dispatch),
    redirectTo: bindActionCreators(push, dispatch),
    ssgFormActions: bindActionCreators(ssgFormActions, dispatch),
    programActions: bindActionCreators(programActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewTouchpointResponseComponent);



// WEBPACK FOOTER //
// src/touchpoints/view-touchpoint-response.component.js